import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
export function FloatingSocialCapsule() {
  const {
    t
  } = useLanguage();
  const [isExpanded, setIsExpanded] = useState(false);
  const socialLinks = [{
    name: 'Instagram',
    url: 'https://instagram.com/thisisneurospice',
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-179">
          <rect x="2" y="2" width="20" height="20" rx="5" ry="5" data-id="element-180" />
          <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" data-id="element-181" />
          <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" data-id="element-182" />
        </svg>
  }, {
    name: 'TikTok',
    url: 'https://tiktok.com/@thisisneurospice',
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" data-id="element-183">
          <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" data-id="element-184" />
        </svg>
  }, {
    name: 'LinkedIn',
    url: 'https://linkedin.com/company/thisisneurospice',
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-185">
          <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" data-id="element-186" />
          <rect x="2" y="9" width="4" height="12" data-id="element-187" />
          <circle cx="4" cy="4" r="2" data-id="element-188" />
        </svg>
  }];
  return <motion.div className="hidden lg:block fixed bottom-8 left-8 z-30" onMouseEnter={() => setIsExpanded(true)} onMouseLeave={() => setIsExpanded(false)} initial={false} data-id="element-189">
      <AnimatePresence mode="wait" data-id="element-190">
        {!isExpanded ? <motion.div key="collapsed" initial={{
        opacity: 0,
        scale: 0.8
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.8
      }} transition={{
        duration: 0.2
      }} className="bg-black text-white px-5 py-2.5 rounded-full border-2 border-white shadow-2xl cursor-pointer hover:bg-gray-900 transition-colors" data-id="element-191">
            <div className="flex items-center gap-2 font-bold text-xs uppercase tracking-wider whitespace-nowrap" data-id="element-192">
              <span data-id="element-193">🧠</span>
              <span data-id="element-194">{t('floating.text')}</span>
            </div>
          </motion.div> : <motion.div key="expanded" initial={{
        opacity: 0,
        scale: 0.8
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.8
      }} transition={{
        duration: 0.2
      }} className="bg-black text-white p-6 rounded-2xl border-2 border-white shadow-2xl" data-id="element-195">
            <div className="text-center mb-4" data-id="element-196">
              <p className="font-black text-lg uppercase tracking-tight mb-1" data-id="element-197">
                {t('floating.text')}
              </p>
              <p className="text-xs text-gray-400 font-mono" data-id="element-198">
                {t('social.handle')}
              </p>
            </div>
            <div className="flex gap-4 justify-center" data-id="element-199">
              {socialLinks.map(social => <a key={social.name} href={social.url} target="_blank" rel="noopener noreferrer" className="w-12 h-12 border-2 border-white rounded-full flex items-center justify-center hover:bg-white hover:text-black transition-all duration-200 hover:scale-110" aria-label={social.name} data-id="element-200">
                  {social.icon}
                </a>)}
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}